import React, { useState } from 'react';
import { builderMode } from './builderMode.ts';
import './App.css';
import Canvas from './screens/Canvas.tsx';
import SidePanel from './components/SidePanel.tsx';
import { Sidebar } from 'primereact/sidebar';
import Preview from './screens/Preview.tsx';
import { ReactFlowProvider } from 'reactflow';

function WhatsappBuilder() {
  const [slideBar, setSlideBar] = useState(true);
  const [panelCollapsed, setPanelCollapsed] = useState(false);
  const [previewBar, setPreviewBar] = useState(false);

  const toggleCollapsed = () => {
    setPanelCollapsed((prev) => !prev);
  };

  return (
    <div className="app-container">
      {/* Sidebar - collapses to an icon rail */}
      <div
        className={`sidebar-container ${slideBar ? 'sidebar-open' : ''} ${panelCollapsed ? 'sidebar-collapsed' : ''}`}
      >
        <Sidebar
          visible={slideBar}
          position="left"
          onHide={() => setSlideBar(false)}
          showCloseIcon={false}
          dismissable={false}
          modal={false}
          className={`custom-sidebar ${panelCollapsed ? 'custom-sidebar-collapsed' : ''}`}
        >
          <SidePanel collapsed={panelCollapsed} toggleCollapsed={toggleCollapsed} />
        </Sidebar>
      </div>

      {/* Canvas Wrapper */}
      <div
        className={`canvas-container ${slideBar ? 'canvas-shift' : ''}`}
      >
        <ReactFlowProvider>
          <Canvas />
        </ReactFlowProvider>
      </div>

       {/* Sidebar - fixed width */}
      <div
        className={`sidebar-container ${previewBar ? 'sidebar-open width-350' : ''}`}
      >
        <Sidebar
          visible={previewBar}
          position="right"
          onHide={() => setPreviewBar(false)}
          showCloseIcon={false}
          dismissable={false}
          className="custom-sidebar width-350"
        >
          <Preview />
        </Sidebar>
      </div>
    </div>
  );
}

const SocialFlowApp = React.lazy(() => import('./social/SocialFlowApp.tsx'));
function App() {
  return builderMode(window.location.search) === 'social'
    ? <React.Suspense fallback={<div role="status">Loading flow builder…</div>}><SocialFlowApp /></React.Suspense>
    : <WhatsappBuilder />;
}
export default App;
